import AccordionTab from "components/util/AccordianTab";
import { Autocomplete, Grid, TextField } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { propertyManager } from "all_Interfaces";
import { getPropertyData, resetPropertyData } from "../../../redux/slices/propertyslice";
import { getPropertyManagerData, getSecondaryPropertyManagerData, resetPropertyManagerData } from "../../../redux/slices/propertyManagerSlice";
import { allSelectedData } from "../../../redux/slices/allSelectedDataSlice";
import { clearValidationError } from "../../../redux/slices/formValidationSlice";
import { getTenantByPropertyData } from "../../../redux/slices/AmendmentTenatByPropertyDataSlice";
import { useParams } from "react-router-dom";

const InvAndProps: React.FC<Record<any, any>> = (props) => {

  const dispatch = useAppDispatch();
  const investments = useAppSelector((state) => state.invData.data.result);
  const property = useAppSelector((state) => state.propertyData);
  const selectedData = useAppSelector((state) => state.allSelectedData);
  const validationErrors = useAppSelector((state) => state.formValidation.errors);
  const { formtype } = useParams();

  const investmentOptions = investments?.map((inv) => ({
    
    label: `${inv.invNum} - ${inv.invName}`,
    value: inv.invNum
  }));
  
  const propertyOptions = property.data.result?.map((prop) => ({
    label: `${prop.propertyNumber} - ${prop.propertyName}`,
    value: prop.propertyNumber
  }));

  const handleInvChange = (event: any, newValue: any) => {
    dispatch(allSelectedData({
      ...selectedData,
      investmentId: newValue?.value || '',
      investmentName: newValue?.label?.split(' - ')[1] || '',
      propertyId: '',
      propertyName: '',
      propertyManager: null,
      secondaryPropertyManager: null
    }));

    // Clear validation error when value is selected
    if (newValue) {
      dispatch(clearValidationError('investment'));
    }

    dispatch(resetPropertyData());
    if (newValue !== null) {
      dispatch(getPropertyData(newValue.value));
    }


  }

  const handlePropChange = (event: any, newValue: any) => {
    dispatch(allSelectedData({
      ...selectedData,
      propertyId: newValue?.value || '',
      propertyName: newValue?.label?.split(' - ')[1] || '',
      propertyManager: null,
      secondaryPropertyManager: null
    }));

    // Clear validation error when value is selected
    if (newValue) {
      dispatch(clearValidationError('property'));
    }
    dispatch(resetPropertyManagerData())
    if (newValue !== null) {
      dispatch(getPropertyManagerData(newValue.value));
      dispatch(getSecondaryPropertyManagerData(newValue.value));
    }

    if (selectedData.leaseType === 'Lease Amendment' && newValue !== null) {
      dispatch(getTenantByPropertyData(newValue?.value));
    }
  }

  return (
    <AccordionTab
      title={"Investment And Property"} children=
      {
        <div>
          <Grid container spacing={3} >
            <Grid item xs={12} md={6}>
              <Grid>
                <label>Investment</label><span className="mandatory"> *</span>
              </Grid>
              <Grid>
                <Autocomplete
                  id="Investment"
                  options={investmentOptions ?? []}
                  getOptionLabel={(option) => option.label || ''}
                  value={selectedData.investmentId ? {
                    label: `${selectedData.investmentId} - ${selectedData.investmentName}`,
                    value: selectedData.investmentId
                  } : null}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={selectedData.investmentId.length === 0 ? "Select" : ""}
                      error={!!validationErrors.investment}
                    />
                  )}
                  size="small"
                  fullWidth={true}
                  onChange={handleInvChange}
                  disabled={formtype === "view" || formtype === "approval"}
                  isOptionEqualToValue={(option: any, value: any) => {
                    return option?.value === value?.value;
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid>
                <label>Property</label><span className="mandatory"> *</span>
              </Grid>
              <Grid>
                <Autocomplete
                  id="Property"
                  options={propertyOptions ?? []}
                  loading={property.loading}
                  getOptionLabel={(option) => option.label || ''}
                  value={selectedData.propertyId ? {
                    label: `${selectedData.propertyId} - ${selectedData.propertyName}`,
                    value: selectedData.propertyId
                  } : null}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={selectedData.propertyId.length === 0 ? "Select" : ""}
                      error={!!validationErrors.property}
                    />
                  )}
                  size="small"
                  fullWidth={true}
                  onChange={handlePropChange}
                  disabled={formtype === "view" || formtype === "approval"}
                  isOptionEqualToValue={(option: any, value: any) => {
                    return option?.value === value?.value;
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </div>
      } />
  )
}

export default InvAndProps;
